import { APP_STORE_URL, PLAY_STORE_URL } from "@groupeo/shared";
import { useTranslation } from "react-i18next";
import { BreadcrumbJsonLd } from "@/src/common/components/breadcrumb-jsonld";
import { JsonLd } from "@/src/common/components/json-ld";
import { PageHelmet } from "@/src/common/components/page-helmet";
import { env } from "@/src/common/constants/env";
import { SiteShell } from "../components/site-shell";
import { StoreButton } from "../components/store-button";
import { MARKETING_ROUTES } from "../constants/marketing-routes";

const DownloadPage: React.FC = () => {
	const { t } = useTranslation("marketing");
	const pageUrl = `${env.SITE_URL}${MARKETING_ROUTES.DOWNLOAD}`;

	return (
		<>
			<PageHelmet title={t("download_page_title")} description={t("download_page_description")} />
			<BreadcrumbJsonLd
				items={[
					{ name: t("breadcrumb_home"), url: env.SITE_URL },
					{ name: t("nav_download"), url: pageUrl },
				]}
			/>
			<JsonLd
				data={{
					"@context": "https://schema.org",
					"@type": "SoftwareApplication",
					name: env.APP_NAME,
					operatingSystem: "iOS, Android",
					applicationCategory: "SocialNetworkingApplication",
					offers: { "@type": "Offer", price: "0", priceCurrency: "EUR" },
					downloadUrl: pageUrl,
					installUrl: [APP_STORE_URL, PLAY_STORE_URL],
				}}
			/>
			<SiteShell>
				<main className="overflow-hidden">
					<div className="mx-auto max-w-5xl px-6 pb-24 pt-8 sm:px-8 lg:px-12">
						<header className="max-w-3xl py-12">
							<p className="text-sm font-semibold uppercase tracking-[0.24em] text-app-accent-secondary">{t("nav_download")}</p>
							<h1 className="mt-4 text-4xl font-semibold tracking-[-0.06em] text-white sm:text-6xl">{t("download_page_title")}</h1>
							<p className="mt-5 text-lg leading-8 text-white/70">{t("download_page_intro")}</p>
						</header>
						<section className="flex flex-col gap-4 rounded-[2rem] border border-white/10 bg-white/6 p-8 sm:flex-row sm:items-center sm:justify-center">
							<StoreButton href={APP_STORE_URL} label={t("hero_primary_cta")} variant="primary" />
							<StoreButton href={PLAY_STORE_URL} label={t("hero_secondary_cta")} variant="secondary" />
						</section>
						<section className="mt-10 rounded-[1.75rem] border border-white/10 bg-white/6 p-6">
							<h2 className="text-xl font-semibold text-white">{t("download_page_requirements_title")}</h2>
							<p className="mt-3 text-sm leading-7 text-white/70">{t("download_page_requirements_body")}</p>
						</section>
					</div>
				</main>
			</SiteShell>
		</>
	);
};

export default DownloadPage;
